import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./NewsVisualizationImpresso.css";

import Loading from "../../../components/Loading/Loading";
import Message from "../../../components/Message/Message";
import { fetchClientClippingDetail } from "../../../services/api/fetchClipping";
import NewsDataRow from "../../../components/NewsDataRow/NewsDataRow";
import ImageCarousel from "../../../components/ImageCarousel/ImageCarousel";
import TextPanel from "../../../components/TextPanel/TextPanel";
import ActionsButtons from "../../../components/ActionsButtons/ActionsButtons";

import { ReactComponent as MediaIcon } from "../../../assets/icons/filter_media_type_icon.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/filter_period_icon.svg";
import { ReactComponent as SourceIcon } from "../../../assets/icons/filter_source_icon.svg";
import { ReactComponent as CategoryIcon } from "../../../assets/icons/filter_category_icon.svg";

function NewsVisualizationImpresso() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadDetail = async () => {
      try {
        setIsLoading(true);
        const res = await fetchClientClippingDetail(id);
        setData(res);
      } catch (err) {
        console.error("Erro ao carregar detalhe:", err);
        setMessage({
          type: "error",
          text: "Não foi possível carregar a notícia.",
        });
      } finally {
        setIsLoading(false);
      }
    };
    if (id) loadDetail();
  }, [id]);

  if (isLoading) return <Loading />;
  if (message) return <Message type={message.type} message={message.text} />;

  if (!data)
    return (
      <div className="container-news-visualization-impresso">
        <p>Nenhuma notícia encontrada.</p>
      </div>
    );

    const handleOpenOriginal = () => {
        if (data?.url) window.open(data.url, "_blank", "noopener,noreferrer");
    };

    const handleBack = () => {
        navigate(-1);
    };

    const carouselImages = (data?.thumbnails?.length
    ? data.thumbnails.map((url) => ({ src: url }))
    : (data?.files || [])
        .filter((f) => !!f.content_file)
        .map((f) => ({ src: f.content_file }))
  );

  return (
    <div className="container-news-visualization-impresso">
        <h1 className="title-news-visualization-impresso">{data.title}</h1>

      <NewsDataRow
        title="Dados:"
        items={[
          {
            icon: MediaIcon,
            text: data?.source_detail?.source_type?.toUpperCase() || "—",
          },
          { icon: CalendarIcon, text: data?.publish_date || "—" },
          {
            icon: SourceIcon,
            text: `${data?.source_detail?.name || ""} ${
              data?.source_detail?.city
                ? `- ${data.source_detail.city.name} / ${data.source_detail.city.state}`
                : ""
            }`,
          },
          {
            icon: CategoryIcon,
            list: (data?.categories || []).map((c) => c?.name?.trim()).filter(Boolean),
            tooltipTitle: "Categorias",
          },
        ]}
      />

      <div
        className={`media-and-content-news-impresso ${
        carouselImages.length === 0 ? "no-image" : ""
      }`}
        >
        {carouselImages.length > 0 && (
            <div>
                <ImageCarousel
                    images={carouselImages}
                    autoPlay={true}
                    interval={4000}
                    showArrows={true}
                    showDots={true}
                    rounded={true}
                />
            </div>
        )}

        <div>
            <TextPanel
                width="100%"
                height={420}
                contentHtml={data?.content_text || data?.content || "<p>Sem conteúdo disponível.</p>"}
            />
        </div>
     </div>

        <ActionsButtons
          text="Voltar"
          onClick={handleBack}
          type="button"
          showCancel={false}
          showSecondary={false}
          showTertiary={false}
        />
    </div>
  );
}

export default NewsVisualizationImpresso;
